import React, { useState } from 'react';

interface LazyImageProps {
  src: string;
  alt: string;
  /** <img> üzerindeki CSS class (ör: lightbox-image) */
  className?: string;
  /** Wrapper div'e uygulanacak inline style */
  wrapStyle?: React.CSSProperties;
  onClick?: () => void;
}

/**
 * Resim yüklenene kadar shimmer (gümüş akan animasyon) gösterir,
 * yüklendikten sonra fade-in ile gösterir.
 * key={src} kullanarak resim değiştiğinde shimmer tekrar tetiklenir.
 */
const LazyImage: React.FC<LazyImageProps> = ({
  src,
  alt,
  className,
  wrapStyle,
  onClick,
}) => {
  const [loaded, setLoaded] = useState(false);

  return (
    <div
      className={`lazy-img-wrap${loaded ? ' lazy-img-loaded' : ' lazy-img-shimmer'}`}
      style={wrapStyle}
      onClick={onClick}
    >
      <img
        src={src}
        alt={alt}
        className={className}
        style={{ opacity: loaded ? 1 : 0, transition: 'opacity 0.4s ease' }}
        onLoad={() => setLoaded(true)}
      />
    </div>
  );
};

export default LazyImage;
